import * as React from "react";
import { EntityDataTable } from "../../list/EntityDataTable";
import { createInitialState } from "../ListView";
import { ColumnType } from "../../list/ColumnType";
import { PagerModel } from "../../list/PagerModel";
import { ListUtils } from "../../list/ListUtils";
import { TransactionHistoryRequest, TransactionHistoryService } from "../../../service/admin/TransactionHistoryService";

let columns = [
    {
        property: "timestamp", name: "Date",
        type: ColumnType.DATE
    },
    { property: "privateComment", name: "Comment", },
    { property: "amount", name: "Amount", type: ColumnType.BIG },
    { property: "balance", name: "Resulting Balance", type: ColumnType.BIG },
    { property: "currencyCode", name: "Currency" },
    { property: "metadata", name: "Metadata" }
];

interface Props {
    userId: string | number,
    accountType: string,
    service?: TransactionHistoryService
}

interface State {
    pager?: any,
    listRequest?: TransactionHistoryRequest
}

export class TransactionHistoryList extends React.Component<Props, State> {

    constructor(props) {
        super(props);
        this.state = createInitialState({
            userId: props.userId,
            accountType: props.accountType,
            limit: 20,
            offset: 0
        }, {});
    }

    pagerChanged(pager: PagerModel) {
        var listRequest = ListUtils.toListRequest<TransactionHistoryRequest>(this.state.listRequest, pager);
        this.setState({ listRequest: listRequest });
    }

    dateChanged(date: number, pager: PagerModel) {
        const newListRequest = ListUtils.toListRequest<TransactionHistoryRequest>(this.state.listRequest, pager)
        newListRequest.fromDate = date;
        this.setState({ listRequest: newListRequest });
    }

    render() {
        return <EntityDataTable
            columns={columns}
            dateEnabled={true}
            service={this.props.service}
            listRequest={this.state.listRequest}
            onPagerChange={this.pagerChanged.bind(this)}
            onDateChange={this.dateChanged.bind(this)}
        />
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/account/TransactionHistoryList.tsx